type GoogleTagManagerQueryParams = {
    gtm_auth?: string;
    gtm_preview?: string;
    gtm_debug?: 'x';
    gtm_cookies_win?: 'x';
};

export function getGoogleTagManagerQueryParamsFromSearch(searchParams: URLSearchParams): GoogleTagManagerQueryParams {
    const auth = searchParams.get('gtm_auth') ?? undefined;
    const preview = searchParams.get('gtm_preview') ?? undefined;
    const debug = searchParams.has('gtm_debug') ? 'x' : undefined;

    return {
        gtm_auth: auth,
        gtm_preview: preview,
        gtm_debug: debug,
        gtm_cookies_win: auth && preview ? 'x' : undefined
    };
}
